import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import side from "../../Assets/Image/admin/side.png";
import men1 from "../../Assets/Image/admin/user.png";
import Menu from "../../Base-Component/Menu/Menu";
import Dialog from "../../Base-Component/Dialog/Dialog";
import axios from "axios";
import { Circles } from "react-loader-spinner";
import logos from "../../Assets/Image/admin/headerLogo.jpg";
import { logoutApi } from "../../Services/ApiServices";
import toast from "react-hot-toast";

function TopMenu(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLogOut, setIsLogOut] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [profilePic, setProfilePic] = useState("");
  const [notificationData, setNotificationData] = useState([
    {
      image: men1,
      text: "John Malto accepted the assignment request.",
      time: "20 min. ago",
    },
    {
      image: men1,
      text: "John Malto accepted the assignment request.",
      time: "20 min. ago",
    },
    {
      image: men1,
      text: "John Malto accepted the assignment request.",
      time: "20 min. ago",
    },
    {
      image: men1,
      text: "John Malto accepted the assignment request.",
      time: "20 min. ago",
    },
    {
      image: men1,
      text: "John Malto accepted the assignment request.",
      time: "20 min. ago",
    },
  ]);

  const Token = localStorage.getItem("token");
  axios.defaults.headers.common["Authorization"] = "Bearer " + Token;

  const handleLogout = () => {
    setIsLoading(true);
    logoutApi()
      .then((res) => {
        if (res.status == 200) {
          localStorage.removeItem('token')
          navigate("/login");
        }
        setIsLoading(false);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          localStorage.removeItem('token')
          navigate("/login")
        } else {
          toast.error(err.response.data.message);
        }
        setIsLoading(false);
      })

  };

  const data = JSON.parse(localStorage.getItem("ADMIN_INFO"));

  useEffect(() => {
    if (data) {
      setProfilePic(data.profilePic);
    }
  }, [data]);

  return (
    <>
      <header className="sticky top-0 z-9 flex w-full bg-white drop-shadow-1 dark:bg-boxdark dark:drop-shadow-none">
        <div className="flex flex-grow items-center justify-between lg:justify-between py-4 px-4 shadow-2 md:px-8">
          <div className="flex items-center justify-between gap-2 sm:gap-4">
            <button
              aria-controls="sidebar"
              onClick={(e) => {
                e.stopPropagation();
                props.setSidebarOpen(!props.sidebarOpen);
              }}
              className="z-99 block rounded-sm border border-stroke bg-white p-1.5 shadow-sm dark:border-strokedark dark:bg-boxdark 2xl:hidden xl:hidden lg:hidden"
            >
              <span className="relative block h-5.5 w-5.5 cursor-pointer">
                <span className="du-block absolute right-0 h-full w-full">
                  <span
                    className={`relative top-0 left-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-[0] duration-200 ease-in-out dark:bg-white ${!props.sidebarOpen && "!w-full delay-300"
                      }`}
                  ></span>
                  <span
                    className={`relative top-0 left-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-150 duration-200 ease-in-out dark:bg-white ${!props.sidebarOpen && "delay-400 !w-full"
                      }`}
                  ></span>
                  <span
                    className={`relative top-0 left-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-200 duration-200 ease-in-out dark:bg-white ${!props.sidebarOpen && "!w-full delay-500"
                      }`}
                  ></span>
                </span>
                <span className="absolute right-0 h-full w-full rotate-45">
                  <span
                    className={`absolute left-2.5 top-0 block h-full w-0.5 rounded-sm bg-black delay-300 duration-200 ease-in-out dark:bg-white ${!props.sidebarOpen && "!h-0 !delay-[0]"
                      }`}
                  ></span>
                  <span
                    className={`delay-400 absolute left-0 top-2.5 block h-0.5 w-full rounded-sm bg-black duration-200 ease-in-out dark:bg-white ${!props.sidebarOpen && "!h-0 !delay-200"
                      }`}
                  ></span>
                </span>
              </span>
            </button>
            <div className="sm:flex items-center fontNew hidden">
              <h4 className="xl:text-xl lg:text-lg md:text-base font-semibold capitalize">
                {" "}
                {location.pathname
                  .split("/")[1]
                  .split("_")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ")}
              </h4>

            </div>
          </div>

          <div className="flex items-center">
            <div>
              <Menu>
                <Menu.Button className="block">
                  <img
                    src={logos}
                    crossOrigin="anonymous"
                    className="w-10 h-10"
                    alt=""
                  />
                </Menu.Button>
                <Menu.Items className="w-56 bg-white mt-6 fontNew">
                  <Menu.Item
                    className="hover:bg-primary hover:text-white text-[#303438] flex justify-between items-center py-3"
                    onClick={() => {
                      navigate("/change_password");
                    }}
                  >
                    <div className="flex items-center">
                      <p className="m-0 ms-3">Change Password</p>
                    </div>
                  </Menu.Item>
                  <Menu.Item
                    className="hover:bg-primary hover:text-white text-[#303438] flex justify-between items-center py-3"
                    onClick={() => {
                      setIsLogOut(true);
                    }}
                  >
                    <div className="flex items-center">
                      <p className="m-0 ms-3">Log out</p>
                    </div>
                  </Menu.Item>
                </Menu.Items>
              </Menu>
            </div>
          </div>
        </div>
      </header>

      <Dialog open={isLogOut} onClose={() => setIsLogOut(false)} size="2xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center text-center my-4 sm:px-16 px-4 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-black mt-6">
                  Log Out?
                </h4>
                <p className="text-sm text-gray-500 my-3">
                  Are you certain you wish to proceed with <br /> logging out?
                </p>
                <div className="mt-13 flex items-center mb-5">
                  <button
                    className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                    onClick={() => setIsLogOut(false)}
                  >
                    Close
                  </button>
                  <button
                    className="bg-primary h-[50px] disabled:bg-red-400 sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    onClick={handleLogout}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      "Yes, Log Out"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>
    </>
  );
}

export default TopMenu;
